import api from './api';

export interface ListaPublicaResumo {
  id: string;
  slug: string;
  tituloLista: string;
  dataCasamento?: string | null;
  localCasamento?: string | null;
  createdAt: string;
}

export interface ListarListasPublicasParams {
  page?: number;
  pageSize?: number;
  search?: string;
}

export interface ListarListasPublicasResponse {
  page: number;
  pageSize: number;
  total: number;
  hasMore: boolean;
  listas: ListaPublicaResumo[];
}

export interface ListaPublica {
  id: string;
  slug: string;
  isOwner?: boolean;
  tituloLista: string;
  saveDateFotoFilename?: string | null;
  dataCasamento?: string | null;
  descricao?: string | null;
  templateSlug?: string | null;
  configuracoes?: {
    babyShowerSubtype?: 'boy' | 'girl' | 'unknown' | string;
    tipoLista?: string;
    enableRsvp?: boolean;
    enableSaveTheDate?: boolean;
    rsvpEventDate?: string | null;
    saveDateEventDate?: string | null;
    saveDateEventTime?: string | null;
    saveDateLocation?: string | null;
    saveDateHeadline?: string | null;
    saveDateDescription?: string | null;
    [key: string]: any;
  };
}

export interface ConfirmacaoPresencaPublica {
  id: string;
  nome: string;
  createdAt: string;
}

export interface ConfirmacaoPresencaResponse {
  total: number;
}

export interface ProdutoAfiliadoResumoPublico {
  id: string;
  nome: string;
  parceiro?: string | null;
  urlAfiliado: string;
}

export interface PresentePublico {
  id: string;
  nome: string;
  descricao?: string | null;
  valor: number;
  categoria?: string | null;
  imagemUrl?: string | null;
  presenteado?: boolean;
  presenteadorNome?: string;
  produtoAfiliado?: ProdutoAfiliadoResumoPublico | null;
  origem?: string | null;
}

export interface ListaPublicaResponse {
  lista: ListaPublica;
}

export interface PresentesPublicosResponse {
  presentes: PresentePublico[];
  categorias: string[];
}

export const listarListasPublicas = async (
  params: ListarListasPublicasParams = {}
): Promise<ListarListasPublicasResponse> => {
  const query: Record<string, string | number> = {};

  if (params.page) query.page = params.page;
  if (params.pageSize) query.pageSize = params.pageSize;
  if (params.search && params.search.trim().length > 0) {
    query.search = params.search.trim();
  }

  const response = await api.get<ListarListasPublicasResponse>('/listas/public', {
    params: query,
  });

  return response.data;
};

export const obterListaPublica = async (slug: string): Promise<ListaPublicaResponse> => {
  const response = await api.get<ListaPublicaResponse>(`/listas/public/${slug}`);
  return response.data;
};

export const listarPresentesPublicos = async (slug: string): Promise<PresentesPublicosResponse> => {
  const response = await api.get<PresentesPublicosResponse>(`/public/${slug}/presentes`);
  return response.data;
};

export const confirmarPresencaPublica = async (
  slug: string,
  payload: { nome: string }
): Promise<{ message: string; confirmacao: ConfirmacaoPresencaPublica; total: number }> => {
  const response = await api.post<{
    message: string;
    confirmacao: ConfirmacaoPresencaPublica;
    total: number;
  }>(`/listas/public/${slug}/presenca`, payload);
  return response.data;
};
